import Service from './Service';
import {SERVER_URL} from "../utils/Constants";
import GeneralUtils from "../utils/GeneralUtils";
import ServiceMember from "./ServiceMember";

export default class PaymentService extends ServiceMember {
    constructor() {
        super();
        this.baseURL = 'dispatchio/payment';
    }

    validateProviderOrThrow(provider) {
        if (GeneralUtils.isNullOrEmpty(provider)) {
            throw new Error("Payment provider is required before creating payment token.");
        }
    }

    async createToken(merchantBranchId,crossReference,address,amount,currencyCode,orderDescription,returnUrl,cancelUrl,originUrl,provider,orderId) {
        this.validateProviderOrThrow(provider);
        let data = {
            "merchantBranchId" : merchantBranchId,
            "crossReference" : crossReference,
            "webHookUrl":SERVER_URL,
            "address":address,
            "basketBssId":localStorage.getItem(localStorage.getItem("merchantBranchId")),
            "amount": amount,
            "currencyCode": currencyCode,
            "orderDescription": orderDescription,
            "returnUrl": returnUrl,
            "cancelUrl": cancelUrl,
            "originUrl": originUrl
        };
        if (!GeneralUtils.isNullOrEmpty(orderId)) {
            data["orderId"] = orderId;
        }
        return fetch(SERVER_URL + this.baseURL + "/token", {
            crossDomain: true,
            method: 'post',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify(data)
        }).then(response => {
            let result = response.clone();
            GeneralUtils.notification(response, true);
            return GeneralUtils.responseToJson(result);
        }).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    async createApplePayToken(merchantBranchId, opts = {}) {
        this.validateProviderOrThrow(opts.provider);
        let initiativeContext = null;
        if (typeof window !== "undefined" && window.location && window.location.hostname) {
            initiativeContext = window.location.hostname;
        } else {
            try {
                initiativeContext = new URL(GeneralUtils.getUiUrl()).hostname;
            } catch (e) {
                initiativeContext = GeneralUtils.getUiUrl().replace("https://", "").replace("http://", "").split("/")[0];
            }
        }
        initiativeContext = (initiativeContext || "").replace(/^www\./i, "").trim();

        // Optional runtime override if needed without code change.
        const envOverride = (typeof process !== "undefined" && process.env && process.env.REACT_APP_APPLE_PAY_INITIATIVE_CONTEXT)
            ? String(process.env.REACT_APP_APPLE_PAY_INITIATIVE_CONTEXT).trim()
            : "";
        if (!GeneralUtils.isNullOrEmpty(envOverride)) {
            initiativeContext = envOverride.replace(/^https?:\/\//i, "").replace(/^www\./i, "").split("/")[0];
        }

        let data = {
            "merchantBranchId" : merchantBranchId,
            "domainName" : initiativeContext,
            "basketBssId":localStorage.getItem(localStorage.getItem("merchantBranchId"))
        };
        if (!GeneralUtils.isNullOrEmpty(opts.validationUrl)) {
            data["validationUrl"] = opts.validationUrl;
        }
        if (!GeneralUtils.isNullOrEmpty(opts.amount)) {
            data["amount"] = String(opts.amount);
        }
        if (!GeneralUtils.isNullOrEmpty(opts.currency)) {
            data["currency"] = opts.currency;
        }
        if (!GeneralUtils.isNullOrEmpty(opts.invoiceId)) {
            data["invoiceId"] = String(opts.invoiceId);
        }
        if (!GeneralUtils.isNullOrEmpty(opts.displayName)) {
            data["displayName"] = opts.displayName;
        }
        return fetch(SERVER_URL + this.baseURL + "/applepay/token", {
            crossDomain: true,
            method: 'post',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify(data)
        }).then(response => {
            let result = response.clone();
            GeneralUtils.notification(response, true);
            return GeneralUtils.responseToJson(result);
        }).catch(error => {
            GeneralUtils.notification(error);
        });
    }



}